module.exports = __webpack_public_path__ + "img/changjing1.ecbe671a.png";